import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: "100%",
      temporary: "",
      stateless: _vm.isMakingDrawerStateless
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer px-8"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.closeDrawer();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("div", [_vm._v("Order dispatch files")])], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openTagsDialog();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Manage tags ")], 1)], 1), _c("div", {
    staticClass: "drawer-section-title"
  }), _c("section", {
    staticClass: "drawer-section-order"
  }, [_vm.loadings.isLoadingAttachedFiles ? _c(VSkeletonLoader, {
    attrs: {
      "max-height": "5rem",
      type: "image"
    }
  }) : [!_vm.attachedFiles.length ? _c("p", {
    staticClass: "flex text-sm text-center"
  }, [_vm._v("No files yet")]) : _vm._e(), _c("div", {
    staticClass: "drawer-file-list"
  }, _vm._l(_vm.attachedFiles, function (file) {
    var _file$tag;
    return _c("div", {
      key: file.id,
      staticClass: "global-file-chip"
    }, [_c("div", {
      staticClass: "tag"
    }, [(_file$tag = file.tag) !== null && _file$tag !== void 0 && _file$tag.id ? _c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: "",
        close: "",
        "close-icon": "mdi-close-thick"
      },
      on: {
        "click:close": function clickClose($event) {
          return _vm.removeTagFromDocument(file.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _c("b", [_vm._v(_vm._s(file.tag.name))])], 1) : _c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: ""
      },
      on: {
        click: function click($event) {
          return _vm.openAddTagToDocument(file.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _c("p", {
      staticClass: "font-italic ma-0"
    }, [_vm._v("Add tag")]), _c(VIcon, {
      attrs: {
        right: ""
      }
    }, [_vm._v("mdi-plus-thick")])], 1)], 1), _c(VChip, {
      staticClass: "drawer-file-chip",
      attrs: {
        close: "",
        label: ""
      },
      on: {
        click: function click($event) {
          return _vm.openFileUrl(file.url);
        },
        "click:close": function clickClose($event) {
          return _vm.removeFile(file.id);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        large: "",
        left: ""
      }
    }, [_vm._v("mdi-cloud-download")]), _vm._v(" " + _vm._s(file.filename) + " ")], 1)], 1);
  }), 0)], _vm.drawer && !_vm.loadings.isLoadingAttachedFiles ? _c("UploaderV2", {
    key: "attached-files",
    attrs: {
      canClear: "",
      idInput: "file-upload-global",
      url: _vm.uploadUrl,
      fileTypes: [".xlsx", ".xlsm", ".jpg", ".png", ".gif", ".pdf"],
      label: "Attach File(s) to wine"
    },
    on: {
      "click:upload": _vm.upload
    }
  }) : _vm._e()], 2), _c("InboundDeliveryRelatedFilesTable", {
    attrs: {
      title: "Wine files",
      items: _vm.wineDocuments,
      documentType: "wine",
      nameKey: "display_name",
      idKey: "id_wine",
      route: "adminWineDetails",
      loading: _vm.loadings.isLoadingWineFiles,
      documentTags: _vm.documentTags
    },
    on: {
      filterList: function filterList(filters) {
        _vm.updateFilters(filters);
        _vm.fetchWineDocuments();
      }
    }
  }), _c("InboundDeliveryRelatedFilesTable", {
    attrs: {
      title: "Winery files",
      items: _vm.wineryDocuments,
      documentType: "winery",
      nameKey: "name",
      idKey: "id",
      route: "adminProducerDetails",
      loading: _vm.loadings.isLoadingWineryFiles,
      documentTags: _vm.documentTags
    },
    on: {
      filterList: function filterList(filters) {
        _vm.updateFilters(filters);
        _vm.fetchWineryDocuments();
      }
    }
  })], 1), _c("ManageDocumentsTagsDialog", {
    ref: "ManageDocumentsTagsDialog",
    on: {
      tagListChanged: function tagListChanged($event) {
        return _vm.tagListChangedUpdate();
      },
      documentTagsFetched: _vm.fetchDocumentTags
    }
  }), _c("AddTagToDocumentDialog", {
    ref: "AddTagToDocumentDialog",
    on: {
      tagAddedToDocument: function tagAddedToDocument($event) {
        return _vm.tagListChangedUpdate();
      },
      openManageTagsDialog: function openManageTagsDialog($event) {
        return _vm.openTagsDialog();
      }
    }
  }), _c("confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };